(function() { window.GUID_2f8b4f5c_3fab_471e_84f8_04e126730a7e = { getGuid: function() { return "2f8b4f5c-3fab-471e-84f8-04e126730a7e"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class RadioButtons extends Controls.ControlValueBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $("#" + params[0]); //contient le Id
                let me = this;
                me.$radios = me.$Control.find("input[type=radio]");
            }
            OnDispose() {
                this.$radios.off("change." + this.controlId);
                this.$Control.off("click." + this.controlId);
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                this.$radios.offon("change." + me.ControlId, function (e) {
                    me.Trigger(RadioButtons.EventNames.RadioButtonsValueChanged, {
                        jqueryEventObject: e,
                        data: {
                            value: me.GetValue(),
                            extraValue: me.GetExtraValue(),
                        },
                    });
                });
                me.$Control.offon("click." + me.controlId, function (e) {
                    const $target = $(e.target);
                    const $radioDescription = $target.closest(".radio-description");
                    if ($radioDescription.length) {
                        const $previous = $radioDescription.prev();
                        if ($previous.hasClass("radio-row")) {
                            const $radioSVG = $previous.find(".radio-svg");
                            if ($radioSVG.length) {
                                $radioSVG.trigger("click");
                            }
                        }
                    }
                    e.stopImmediatePropagation();
                });
            }
            GetValue() {
                if (this.$Control.find(":checked").val() == null) {
                    return null;
                }
                return this.$Control.find(":checked").val().toLocaleLowerCase();
            }
            GetExtraValue() {
                return this.$Control.find(":checked").data("html");
            }
            SetValue(value) {
                let end = this.$radios.length;
                let me = this;
                for (var i = 0; i < end; i++) {
                    let $radio = $(this.$radios[i]);
                    if ($radio.val().toString().toLocaleLowerCase() ==
                        value.toString().toLocaleLowerCase()) {
                        $radio.prop("checked", true);
                        $radio.trigger("change." + me.ControlId);
                        break;
                    }
                }
            }
        }
        Controls.RadioButtons = RadioButtons;
        (function (RadioButtons) {
            class Events extends Controls.ControlValueBase.Events {
                static RadioButtonsValueChanged(param) {
                    Controls.RegisterEvent(RadioButtons, EventNames.RadioButtonsValueChanged, param);
                }
            }
            RadioButtons.Events = Events;
            class EventNames extends Controls.ControlValueBase.EventNames {
            }
            EventNames.RadioButtonsValueChanged = "radiobuttons-valuechanged";
            RadioButtons.EventNames = EventNames;
        })(RadioButtons = Controls.RadioButtons || (Controls.RadioButtons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=radiobuttons.js.map
